"use strict";

// react porting for Delighters.js (https://github.com/Q42/delighters)
// all credits belong to original author Martin Kool
var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var ReactDelighters = /** @class */function (_super) {
  __extends(ReactDelighters, _super);
  function ReactDelighters(props) {
    var _this = _super.call(this, props) || this;
    _this._init = function () {
      var options = _this.props.options;
      var dels = _this.dels;
      document.addEventListener('scroll', _this._scroll);
      var els = document.querySelectorAll('[' + options.attribute + ']');
      for (var i = 0; i < els.length; i++) {
        var el = els[i],
          def = el.getAttribute(options.attribute),
          pairs = def === null || def === void 0 ? void 0 : def.split(';'),
          del = {};
        del.start = options.start;
        del.end = options.end;
        for (var j = 0; j < pairs.length; j++) {
          var pair = pairs[j].split(':'),
            name = pair[0],
            val = isNaN(pair[1] * 1) ? pair[1] : pair[1] * 1;
          if (name) del[name] = val === undefined ? true : val;
        }
        del.el = el;
        del.id = dels.length;
        dels.push(del);
        el.classList.add(options.classNames[0]);
        // if (del.debug) el.setAttribute(style.outline = 'solid red 4px';
      }

      _this._scroll();
    };
    _this._scroll = function () {
      var options = _this.props.options;
      var dels = _this.dels;
      var viewportHeight = window.innerHeight;
      for (var i = 0; i < dels.length; i++) {
        var del = dels[i],
          box = del.el.getBoundingClientRect(),
          factorStart = box.top / viewportHeight,
          factorEnd = box.bottom / viewportHeight;
        if (del.debug) {
          if (factorStart >= 0 && factorStart <= 1) {
            if (!del.startLine) {
              del.startLine = document.createElement('div');
              document.body.appendChild(del.startLine);
              del.startLine.style = 'position:fixed;height:0;width:100%;border-bottom:dotted red 2px;top:' + del.start * 100 + 'vh';
            }
          }
          if ((factorEnd < del.end || factorStart > 1) && del.startLine) {
            del.startLine.parentNode.removeChild(del.startLine);
            delete del.startLine;
          }
        }
        if (factorStart < del.start && !del.started) {
          del.started = true;
          del.el.classList.add(options.classNames[1]);
        } else if (factorStart > del.start && del.started) {
          del.started = false;
          del.el.classList.remove(options.classNames[1]);
        }
        if (factorEnd < del.end && !del.ended) {
          del.ended = true;
          del.el.classList.add(options.classNames[2]);
        } else if (factorEnd > del.end && del.ended) {
          del.ended = false;
          del.el.classList.remove(options.classNames[2]);
        }
      }
    };
    _this.dels = [];
    return _this;
  }
  ReactDelighters.prototype.componentDidMount = function () {
    this._init();
  };
  ReactDelighters.prototype.render = function () {
    return this.props.children;
  };
  ReactDelighters.defaultProps = {
    options: {
      attribute: 'data-delighter',
      classNames: ['delighter', 'started', 'ended'],
      start: 0.75,
      end: 0.75,
      autoInit: true // initialize when DOMContentLoaded
    }
  };

  return ReactDelighters;
}(react_1.default.Component);
exports.default = ReactDelighters;